import * as React from 'react';
import { AssetPathContext } from '../context/AssetPathContext';
export function useAssetPath(assetKey) {
  return React.useContext(AssetPathContext)(assetKey);
}